import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request;
  return {
    userLogin: function userLogin() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = new URLSearchParams();
      params.set('username', data.username);
      params.set('password', data.password);
      return request({
        url: '/user/login',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: params
      });
    }
  };
});